import axios from "../../axios";

// Курс платформних уроків з групи й рівня матеріалів: adults + beginner → "adults-beginner"
export const courseOf = (group, level) =>
  group && level ? `${group}-${String(level).trim().toLowerCase().replace(/\s+/g, "-")}` : null;

// Уроки курсу (без слайдів). Учням сервер віддає лише опубліковані
export const fetchPlatformLessons = async (course) => {
  if (!course) return [];
  const { data } = await axios.get("platform-lessons", { params: { course } });
  return Array.isArray(data) ? data : [];
};

// Усі уроки платформи (для «Матеріали → Уроки платформи»: які групи/рівні вже мають уроки)
export const fetchAllPlatformLessons = async () => {
  const { data } = await axios.get("platform-lessons");
  return Array.isArray(data) ? data : [];
};

// Посилання на урок у «Матеріалах» / звіті по уроку — так платформні уроки відрізняються від Canva
export const platformLessonUrl = (lessonId) => `/present/${lessonId}`;
export const isPlatformLessonUrl = (url = "") => String(url).startsWith("/present/");

// Джерело матеріалів учня (поле materialsSource у картці): "platform" | "canva" (за замовчуванням — Canva).
// Платформа діє лише якщо для групи+рівня учня є уроки платформи, інакше показуємо Canva — учень не лишиться без уроків.
export const MATERIALS_SOURCES = [
  { value: "platform", name: "Уроки платформи" },
  { value: "canva", name: "Canva" },
];
export const wantsPlatform = (student) => student?.materialsSource === "platform";

// Чи є уроки платформи для групи+рівня (курси: adults-beginner, …). Для форми додавання й картки учня
export const fetchPlatformCourses = async () => {
  const lessons = await fetchAllPlatformLessons().catch(() => []);
  return [...new Set(lessons.map((lesson) => lesson.course))];
};
